import { ref, onMounted } from 'vue';

const isDark = ref(false);

export function useTheme() {
  
  // Fonction qui bascule la classe et sauvegarde
  const toggleTheme = () => {
    isDark.value = !isDark.value;
    updateHtmlClass();
  };

  // Met à jour le DOM et le LocalStorage
  const updateHtmlClass = () => {
    const html = document.documentElement;
    if (isDark.value) {
      html.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      html.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  };

  // Initialisation au chargement de l'app
  const initTheme = () => {
    const savedTheme = localStorage.getItem('theme');
    // On vérifie le localStorage ou la préférence système
    if (savedTheme === 'dark' || (!savedTheme && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
      isDark.value = true;
    } else {
      isDark.value = false;
    }
    updateHtmlClass();
  };

  return { isDark, toggleTheme, initTheme };
}